/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';
import { useProduct } from '@modules/product';
import { GIFT_CARD_TYPE } from '../constants/giftcard';

/**
 * * ATB Gift Card Payload
 * @param {ReturnType<import('../composables').useGiftCardForm>['values']} values - Gift card form values
 * @param {import('../constants').GIFT_CARD_TYPE} giftCardType - Gift card type
 * @returns
 */
export const useGiftPayload = (values, giftCardType) => {
  const { productData } = useProduct();
  const payload = { productType: productData.detail.typeName };

  return computed(() => {
    if (giftCardType === GIFT_CARD_TYPE.CONSOLIDATED_MASTER) {
      return payload;
    }
    return {
      ...payload,
      ...values,
      isEGiftCard: giftCardType === GIFT_CARD_TYPE.E_GIFT_CARD,
    };
  });
};
